<template>
  <div>
    <v-dialog
      v-model="dialog"
      max-width="1140"
      :persistent="loading"
      scrollable
      :fullscreen="$vuetify.breakpoint.xsOnly"
    >
      <v-card>
        <v-card-title>
          {{ feature.id ? "Editar" : "Nova" }} funcionalidade
        </v-card-title>

        <v-tabs v-model="tab" grow>
          <v-tab>Formulário</v-tab>
          <v-tab>Visualização</v-tab>
        </v-tabs>

        <v-card-text class="feature-dialog-content pt-0 px-0">
          <v-alert v-if="error" type="error" dense class="mb-3">
            {{ error }}
          </v-alert>

          <v-tabs-items v-model="tab">
            <v-tab-item>
              <v-form v-model="valid" @submit.prevent>
                <v-tabs v-model="formTab" class="mb-4" show-arrows>
                  <v-tab>Geral</v-tab>
                  <v-tab>Apresentação</v-tab>
                  <v-tab>Conteúdo</v-tab>
                  <v-tab>Mídia</v-tab>
                </v-tabs>

                <v-tabs-items v-model="formTab">
                  <!-- Geral -->
                  <v-tab-item class="px-6">
                    <v-row dense class="ma-0">
                      <v-col cols="12" sm="6">
                        <v-text-field
                          v-model="feature.slug"
                          label="Slug"
                          outlined
                          dense
                          hint="Ex: ticket-management"
                          persistent-hint
                          :disabled="loading"
                          :rules="[(v) => !!v || 'Slug é obrigatório']"
                        />
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-select
                          v-model="feature.status"
                          :items="statusItems"
                          item-text="text"
                          item-value="value"
                          label="Status"
                          outlined
                          dense
                          :disabled="loading"
                        />
                      </v-col>
                      <v-col cols="12" sm="8">
                        <v-text-field
                          v-model="feature.title"
                          label="Título"
                          outlined
                          dense
                          :disabled="loading"
                          :rules="[(v) => !!v || 'Título é obrigatório']"
                        />
                      </v-col>
                      <v-col cols="12" sm="4">
                        <v-text-field
                          v-model="feature.icon"
                          label="Ícone (MDI)"
                          outlined
                          dense
                          :disabled="loading"
                          :rules="[(v) => !!v || 'Ícone é obrigatório']"
                        >
                          <template v-slot:append>
                            <v-icon>{{ feature.icon }}</v-icon>
                          </template>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field
                          v-model="feature.subtitle"
                          label="Subtítulo"
                          outlined
                          dense
                          :disabled="loading"
                        />
                      </v-col>
                      <v-col cols="12">
                        <v-textarea
                          v-model="feature.description"
                          label="Descrição"
                          outlined
                          dense
                          rows="4"
                          :disabled="loading"
                          :rules="[(v) => !!v || 'Descrição é obrigatória']"
                        />
                      </v-col>

                      <v-col cols="12">
                        <v-select
                          v-model="feature.audienceIds"
                          :items="audienceOptions"
                          item-text="name"
                          item-value="id"
                          label="Públicos-alvo"
                          outlined
                          dense
                          multiple
                          chips
                          small-chips
                          :disabled="loading"
                        />
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-switch
                          v-model="feature.public"
                          label="Pública"
                          hide-details
                          class="mt-0"
                          :disabled="loading"
                        />
                      </v-col>
                    </v-row>
                  </v-tab-item>

                  <!-- Apresentação -->
                  <v-tab-item class="px-6">
                    <v-row dense class="ma-0">
                      <v-col cols="12" sm="6">
                        <v-combobox
                          v-model="feature.path"
                          label="Caminho (breadcrumb)"
                          outlined
                          dense
                          multiple
                          chips
                          small-chips
                          :disabled="loading"
                        />
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-combobox
                          v-model="feature.categories"
                          label="Categorias"
                          outlined
                          dense
                          multiple
                          chips
                          small-chips
                          :disabled="loading"
                        />
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-text-field
                          v-model="feature.ctaLabel"
                          label="Texto do CTA"
                          outlined
                          dense
                          :disabled="loading"
                        />
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-text-field
                          v-model="feature.ctaUrl"
                          label="URL do CTA"
                          outlined
                          dense
                          :disabled="loading"
                        />
                      </v-col>
                    </v-row>
                  </v-tab-item>

                  <!-- Conteúdo -->
                  <v-tab-item class="px-6">
                    <div class="d-flex justify-space-between align-center mb-2">
                      <h6>Links</h6>
                      <v-btn
                        small
                        text
                        color="primary"
                        :disabled="loading"
                        @click="addLink"
                      >
                        <v-icon left small>mdi-plus</v-icon>
                        Adicionar
                      </v-btn>
                    </div>
                    <v-card
                      v-for="(link, index) in feature.links"
                      :key="`link-${index}`"
                      outlined
                      class="mb-3 pa-3"
                    >
                      <v-row dense align="center" class="ma-0">
                        <v-col cols="12" sm="5">
                          <v-text-field
                            v-model="link.label"
                            label="Label"
                            outlined
                            dense
                            hide-details
                            :disabled="loading"
                          />
                        </v-col>
                        <v-col cols="12" sm="6">
                          <v-text-field
                            v-model="link.url"
                            label="URL"
                            outlined
                            dense
                            hide-details
                            :disabled="loading"
                          />
                        </v-col>
                        <v-col cols="12" sm="1" class="text-right">
                          <v-btn
                            icon
                            small
                            :disabled="loading"
                            @click="removeLink(index)"
                          >
                            <v-icon>mdi-delete</v-icon>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card>

                    <v-divider class="my-4" />

                    <div class="d-flex justify-space-between align-center mb-2">
                      <h6>Principais benefícios</h6>
                      <v-btn
                        small
                        text
                        color="primary"
                        :disabled="loading"
                        @click="addBenefit"
                      >
                        <v-icon left small>mdi-plus</v-icon>
                        Adicionar
                      </v-btn>
                    </div>
                    <v-card
                      v-for="(benefit, index) in feature.mainBenefits"
                      :key="`benefit-${index}`"
                      outlined
                      class="mb-3 pa-3"
                    >
                      <div class="d-flex align-center mb-2 gap-2">
                        <v-text-field
                          v-model="benefit.title"
                          label="Título"
                          outlined
                          dense
                          hide-details
                          :disabled="loading"
                        />
                        <v-btn
                          icon
                          small
                          :disabled="loading"
                          @click="removeBenefit(index)"
                        >
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </div>
                      <v-textarea
                        v-model="benefit.description"
                        label="Descrição"
                        outlined
                        dense
                        hide-details
                        :disabled="loading"
                      />
                    </v-card>

                    <v-divider class="my-4" />

                    <div class="d-flex justify-space-between align-center mb-2">
                      <h6>FAQ</h6>
                      <v-btn
                        small
                        text
                        color="primary"
                        :disabled="loading"
                        @click="addFaq"
                      >
                        <v-icon left small>mdi-plus</v-icon>
                        Adicionar
                      </v-btn>
                    </div>
                    <v-card
                      v-for="(item, index) in feature.faq"
                      :key="`faq-${index}`"
                      outlined
                      class="mb-3 pa-3"
                    >
                      <div class="d-flex align-center mb-2 gap-2">
                        <v-text-field
                          v-model="item.question"
                          label="Pergunta"
                          outlined
                          dense
                          hide-details
                          :disabled="loading"
                        />
                        <v-btn
                          icon
                          small
                          :disabled="loading"
                          @click="removeFaq(index)"
                        >
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </div>
                      <v-textarea
                        v-model="item.answer"
                        label="Resposta"
                        outlined
                        dense
                        hide-details
                        :disabled="loading"
                      />
                    </v-card>
                  </v-tab-item>

                  <!-- Mídia -->
                  <v-tab-item class="px-6">
                    <div class="d-flex justify-space-between align-center mb-2">
                      <h6 class="text-subtitle-2">Screenshots</h6>
                      <v-btn
                        small
                        text
                        color="primary"
                        :disabled="loading"
                        @click="addScreenshotUrl"
                      >
                        <v-icon left small>mdi-plus</v-icon>
                        URL
                      </v-btn>
                    </div>
                    <v-card
                      v-for="(shot, index) in feature.screenshots"
                      :key="`shot-${index}`"
                      outlined
                      class="mb-3 pa-3"
                    >
                      <v-row dense align="center">
                        <v-col cols="12" sm="8">
                          <v-text-field
                            v-model="feature.screenshots[index]"
                            label="URL da screenshot"
                            outlined
                            dense
                            hide-details
                            :disabled="loading"
                          />
                        </v-col>
                        <v-col cols="12" sm="3">
                          <v-file-input
                            v-if="feature.id"
                            dense
                            outlined
                            hide-details
                            accept="image/*"
                            label="Upload"
                            prepend-icon="mdi-upload"
                            :disabled="loading"
                            @change="(file) => uploadScreenshotAt(index, file)"
                          />
                        </v-col>
                        <v-col cols="12" sm="1" class="text-right">
                          <v-btn
                            icon
                            small
                            :disabled="loading"
                            @click="removeScreenshot(index)"
                          >
                            <v-icon>mdi-delete</v-icon>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card>
                    <v-alert
                      v-if="!feature.id"
                      type="info"
                      dense
                      text
                      class="mt-2"
                    >
                      Salve a funcionalidade antes de fazer upload de
                      screenshots.
                    </v-alert>
                    <v-file-input
                      v-if="feature.id"
                      dense
                      outlined
                      class="mt-2"
                      accept="image/*"
                      label="Adicionar screenshot via upload"
                      prepend-icon="mdi-image-plus"
                      :disabled="loading"
                      @change="addScreenshotUpload"
                    />
                  </v-tab-item>
                </v-tabs-items>
              </v-form>
            </v-tab-item>

            <v-tab-item>
              <FeatureDisplay embedded :value="previewFeature" />
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>

        <v-card-actions>
          <v-btn
            color="primary"
            class="mb-2"
            :disabled="loading"
            @click="openAiGenerate"
            text
          >
            <v-icon left>mdi-robot</v-icon>
            Gerar com IA
          </v-btn>
          <v-spacer />
          <v-btn text :disabled="loading" @click="close">Cancelar</v-btn>
          <v-btn
            color="primary"
            :loading="loading"
            :disabled="!valid"
            @click="save"
          >
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <FeatureAiGenerate ref="aiGenerateModal" />
  </div>
</template>

<script>
import featuresService from "@/services/ultimate/features";
import featureAudiencesService from "@/services/ultimate/featureAudiences";
import FeatureDisplay from "@/components/ultimate/feature/FeatureDisplay.vue";
import FeatureAiGenerate from "@/components/ultimate/feature/FeatureAiGenerate.vue";
import { defaultFeature, statusItems } from "@/utils/featureUtils";

export default {
  name: "FeatureDialog",
  components: { FeatureDisplay, FeatureAiGenerate },
  data() {
    return {
      dialog: false,
      tab: 0,
      formTab: 0,
      valid: false,
      loading: false,
      error: null,
      feature: defaultFeature(),
      audienceOptions: [],
      statusItems,
    };
  },
  computed: {
    previewFeature() {
      const audiences = this.audienceOptions.filter((item) =>
        (this.feature.audienceIds || []).includes(item.id)
      );
      return {
        ...this.feature,
        audiences,
      };
    },
  },
  methods: {
    addLink() {
      this.feature.links.push({ label: "", url: "" });
    },
    removeLink(index) {
      this.feature.links.splice(index, 1);
    },
    addBenefit() {
      this.feature.mainBenefits.push({ title: "", description: "" });
    },
    removeBenefit(index) {
      this.feature.mainBenefits.splice(index, 1);
    },
    addFaq() {
      this.feature.faq.push({ question: "", answer: "" });
    },
    removeFaq(index) {
      this.feature.faq.splice(index, 1);
    },
    addScreenshotUrl() {
      this.feature.screenshots.push("");
    },
    removeScreenshot(index) {
      this.feature.screenshots.splice(index, 1);
    },
    async uploadScreenshotAt(index, file) {
      if (!file || !this.feature.id) return;
      try {
        this.loading = true;
        const response = await featuresService.uploadScreenshot(
          this.feature.id,
          file
        );
        this.$set(this.feature.screenshots, index, response.url);
      } catch (error) {
        this.error = error.message || "Erro ao enviar screenshot";
      } finally {
        this.loading = false;
      }
    },
    async addScreenshotUpload(file) {
      if (!file || !this.feature.id) return;
      try {
        this.loading = true;
        const response = await featuresService.uploadScreenshot(
          this.feature.id,
          file
        );
        this.feature.screenshots.push(response.url);
      } catch (error) {
        this.error = error.message || "Erro ao enviar screenshot";
      } finally {
        this.loading = false;
      }
    },
    async openAiGenerate() {
      const audiences = this.audienceOptions.filter((item) =>
        (this.feature.audienceIds || []).includes(item.id)
      );
      const suggestion = await this.$refs.aiGenerateModal.open({
        feature: this.feature,
        audiences,
      });
      if (!suggestion) return;

      const preserved = {
        id: this.feature.id,
        audienceIds: this.feature.audienceIds,
        screenshots: this.feature.screenshots,
        status: this.feature.status,
        public: this.feature.public,
        ctaUrl: this.feature.ctaUrl,
        links: this.feature.links,
        path: this.feature.path,
      };
      Object.assign(this.feature, suggestion, preserved);
    },
    normalizeFeature(feature = null) {
      const base = Object.assign(
        defaultFeature(),
        structuredClone(feature || {})
      );
      base.path = Array.isArray(base.path) ? base.path : [];
      base.screenshots = Array.isArray(base.screenshots)
        ? base.screenshots
        : [];
      base.links = Array.isArray(base.links) ? base.links : [];
      base.categories = Array.isArray(base.categories) ? base.categories : [];
      base.mainBenefits = Array.isArray(base.mainBenefits)
        ? base.mainBenefits
        : [];
      base.faq = Array.isArray(base.faq) ? base.faq : [];
      base.audienceIds = (base.audiences || []).map((item) => item.id);
      return base;
    },
    async loadAudiences() {
      const response = await featureAudiencesService.getAll();
      this.audienceOptions = (response.audiences || []).filter(
        (item) => item.active !== false
      );
    },
    async open(feature = null) {
      await this.loadAudiences();
      this.feature = this.normalizeFeature(feature);
      this.error = null;
      this.loading = false;
      this.tab = 0;
      this.formTab = 0;
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.feature = defaultFeature();
      this.error = null;
      this.tab = 0;
      this.formTab = 0;
    },
    buildPayload() {
      const payload = { ...this.feature };
      delete payload.audiences;
      payload.screenshots = payload.screenshots.filter((url) => url?.trim());
      payload.links = payload.links.filter(
        (link) => link.label?.trim() && link.url?.trim()
      );
      payload.mainBenefits = payload.mainBenefits.filter(
        (item) => item.title?.trim() && item.description?.trim()
      );
      payload.faq = payload.faq.filter(
        (item) => item.question?.trim() && item.answer?.trim()
      );
      return payload;
    },
    async save() {
      this.loading = true;
      this.error = null;
      try {
        const payload = this.buildPayload();
        if (this.feature.id) {
          await featuresService.update(payload);
        } else {
          await featuresService.create(payload);
        }
        this.$emit("success");
        this.close();
      } catch (error) {
        this.error = error.message || "Erro ao salvar funcionalidade";
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    this.$root.$on("feature-modal", this.open);
  },
  beforeDestroy() {
    this.$root.$off("feature-modal", this.open);
  },
};
</script>

<style scoped>
.feature-dialog-content {
  overflow-x: hidden;
}
</style>
